
import { localconsole } from "../../App"
import { Comp, CompDictionary, getCompReference } from "./comp"
import { Ship, ShipDictionary } from "./ship"
import { ColorDictionary, KVProps, OptionDictionary } from "./types"
import SparkMD5 from 'spark-md5';

export const default_options = {
        "Legend": false,
        "Orthogonal": true,
        "Fields": true,
        "Structural": true,
        "Namespaces": true,
        "Standalones": true,
    } as OptionDictionary

export interface ProjectBuilder {
  name: string,
  title: string | null,
    diagramHash: string | null,
    is_cached: boolean, //Edit261008 add svg caching
    version?: number,
    existingComponentIds: string[],
    components: CompDictionary,
    existingShipIds: string[],
    ships: ShipDictionary,
    options: OptionDictionary,
    colors: ColorDictionary,
}

export const newProjectBuilder: ProjectBuilder = {
  name: "",
  title: "",
  diagramHash: "",
  is_cached: false,
  version: 0,
  existingComponentIds: [] as string[],
  components: {} as CompDictionary, //e.g. 1: Table
  existingShipIds: [] as string[],
  ships: {} as ShipDictionary, //e.g. 1: Ship
  options: {...default_options},
  colors: {
    "Background": "SteelBlue"
  },
}

export function projectBuilderToString(pb: ProjectBuilder | null, spaces?: number) {
    localconsole("ENTER: projectBuilderToString")
    //localconsole(code)
    let code = pb ?? newProjectBuilder;
    //remove the ids from the objects
    let displayCode = {
        ...{
            ...code,
            components : Object.entries<Comp>(code.components).map(([i, compInstance]) => { return {...compInstance, id: undefined, columns: (compInstance.columns ?? []).map((column) => {return {...column, id:undefined}})} }),
            ships: Object.entries<Ship>(code.ships).map(([i, shipInstance]) => { return {...shipInstance, id:undefined} })
        },
    }
    //localconsole("exiting")
    return JSON.stringify(displayCode, null, spaces ?? 2)
}

export function convertToPayload(pb: ProjectBuilder) {
  localconsole("ENTER: convertToPayload")
  let payload = JSON.stringify({
    "berd_payload": {
      "name": pb.name,
      "title": pb.title,
      "components": pb.components,
      "relationships": pb.ships,
      "options": pb.options,
      "colors": pb.colors,
      //"title/footer" (dont have this state yet, just add a textbox above and below diagram and only show it if it has a non empty value
      "version": pb.version,
    }
  });
  localconsole(`converted to payload: ${payload}`)
  return payload
}

export function getDiagramHash(pb: ProjectBuilder) {
  //
  // commenting to make fn sync so reducers can call
  // let buffer = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(convertToPayload(pb)));
  //let hash = Array.from(new Uint8Array(buffer)).map(b => b.toString(16).padStart(2, '0')).join('');
  let hash = SparkMD5.hash(convertToPayload(pb));
  //
  return hash
}

// this will throw, which is used by builder to set JSONValid value to indicate when there is an issue in converting
export function restructureState(jsonString: string) {
    localconsole("ENTER: restructureState")
    localconsole(jsonString)
    let tree = JSON.parse(jsonString)

    localconsole(".restructureState: JSON parsed, transforming array if needed...")
    //transform array to object
    let comp: CompDictionary = {}
    let ship: ShipDictionary = {}
    let options: OptionDictionary = { ...default_options }
    let colors: ColorDictionary = {}
    let compIds: string[] = [];
    let shipIds: string[] = [];
    if (Array.isArray(tree.components)) {
        localconsole("is array")
        tree.components.forEach((c: Comp, i: number) => {
//          let new_id = crypto.randomUUID();
           const new_id = c.id || crypto.randomUUID();
            comp[i.toString()] = {...c, id: new_id};
            comp[i.toString()].columns.forEach((column) => {
                column.id = crypto.randomUUID()
            })
            compIds.push(new_id)
        })
    } else {
        if (typeof tree.components === "object") {
            localconsole("is object")
          Object.entries(tree.components).forEach(([k, c], i) => {
              let ccomp = c as Comp
              //let new_id = crypto.randomUUID()
               const new_id = ccomp.id || crypto.randomUUID();
                comp[i.toString()] = {
                    ...c as Comp,
                    id: new_id
                }
                compIds.push(new_id)
            })
        }
    }


    localconsole(".restructureState: Checking for relationships attribute")
    if (tree.relationships && !tree.ships) {
        tree.ships = tree.relationships
    }
    if (Array.isArray(tree.ships)) {
        tree.ships.forEach((s: Ship, i: number) => {
          //let new_id = crypto.randomUUID();
            const new_id = s.id || crypto.randomUUID();
            ship[i.toString()] = {...s, id: new_id}
            shipIds.push(new_id)
        })

    } else {
        if (typeof tree.ships === "object") {
          Object.entries(tree.ships).forEach(([k, s], i) => {
              let sship = s as Ship
              const new_id = sship.id || crypto.randomUUID();
                ship[i.toString()] = {
                    ...s as Ship,
                    id: new_id
                }

                shipIds.push(new_id)
            })
        }
    }
    localconsole(".restructureState: Checking for options attribute")
    for (let o in tree.options) {
        options[o] = !!tree.options[o]
    }
    localconsole(".restructureState: Checking for colors attribute")
    for (let o in tree.colors) {
        colors[o] = tree.colors[o]
    }
    let restructured: ProjectBuilder = {
        ...newProjectBuilder,
      name: tree.name,
      title: tree.title ?? "",
        existingComponentIds:  compIds,
        components: comp,
        existingShipIds: shipIds,
        ships: ship,
        options: options,
        colors: colors
    }
    localconsole(".restructureState: Restructured")
  localconsole(restructured)
  //finally ensure diagramHash is updated so cache can work if needed
    restructured.diagramHash = getDiagramHash(restructured)
    return restructured;
}
